module.exports = __webpack_public_path__ + "static/MathemaTIC_Curriculum_-66244599403f76eeebfd77f5a713bdf3.pdf";